import { PropsWithChildren } from "react";

export default function MainLayout({ children }: PropsWithChildren) {
  return (
    <div className="relative flex flex-col justify-between min-h-[100vh] h-[100%] bg-white dark:bg-gray-800">
      <div className="flex flex-col h-full pb-[40px] overflow-y-auto overflow-x-hidden bg-white dark:bg-gray-800 text-content-primary dark:text-gray-100">
        {children}
        <div id="portal-root" />
      </div>

      <div className="bg-white dark:bg-transparent dark:z-10 absolute flex flex-col justify-end bottom-0 left-0 right-0 z-[-2] h-12">
        <span className="block text-gray-450 dark:text-gray-100 text-center text-[11px] font-[400] p-2 z-1">
          © 2026 Meridian AI Inc. All rights reserved
        </span>
      </div>
    </div>
  );
}
